import { render, staticRenderFns } from "./DRadio.vue?vue&type=template&id=70d843a5"
import script from "./DRadio.vue?vue&type=script&lang=js"
export * from "./DRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports